export default __webpack_public_path__ + "images/0x6202b9f02e30e5e1c62cc01e4305450e5d83b926.png";